module.exports = {
  designationCode: 'ltn-na',
  plugins: {
    hq: {
      site_title: 'Livestock Transport Nation',
      site_tagline: 'Simplify Livestock Logistics. Since 2018.',
      privacy_policy: 'https://www.livestocktransportnation.com/privacy-policy?cleanMode=true',
      contact_info: {
        contact_us_href: 'https://www.livestocktransportnation.com/contact-us',
        site_corner_image: '/static/ltn_transparent.png',
      },
    },
    locality: {
      lang: 'en',
      country: 'US',
      locale: 'en-US',
      load_map: {
        // allowed country for map initzer
        country_restrictions: ['us'],
        center: {
          lat: 37.090240,
          lng: -95.712891,
        },
      },
      units_of_measure: 'imperial',
      is_usa: true,
    },
    loadboard: {
      enabled: true,
      states: [],
      enableBidding: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/api/siteDesignations/ltn-na.js